import type { MeasurementStrategyContext, PdpMeasurementStrategy } from './PdpMeasurementStrategy';

/**
 * Baseline PDP scroll engagement for Shopware 6.6 storefront: heartbeat payloads need viewport-relative
 * scroll depth without coupling that logic to gallery or configurator strategies.
 *
 * Plugin coverage: none — core storefront only (CMP/consent can delay when the client attaches; that
 * does not change scroll semantics).
 */
export class DefaultShopware66CoreStrategy implements PdpMeasurementStrategy {
  private onScroll: (() => void) | null = null;

  private ctx: MeasurementStrategyContext | null = null;

  attach(ctx: MeasurementStrategyContext): void {
    this.ctx = ctx;
    const { events, store, window: win } = ctx;

    this.onScroll = () => {
      store.setScrollDepthCurrent(win.scrollY);
      store.setViewportHeight(win.innerHeight);
    };

    events.on(win, 'scroll', this.onScroll, { passive: true });
    this.onScroll();
  }

  dispose(): void {
    if (this.onScroll != null && this.ctx != null) {
      this.ctx.events.off(this.ctx.window, 'scroll', this.onScroll, { passive: true });
    }
    this.onScroll = null;
    this.ctx = null;
  }
}
